import Typography from '@material-ui/core/Typography'
import { makeStyles } from '@material-ui/core/styles'
import clsx from 'clsx'
import { ManufacturerProductPropertyDetail } from 'components/Models/product'
import GridContainer from 'components/Surfaces/GridContainer'
import GridItem from 'components/Surfaces/GridItem'
import { SwitchButton } from 'components/Widgets/ProductListing/Details/SwitchButton'
import {
    getNormalizedProperties,
    getSelectedProperties,
} from 'components/Widgets/ProductListing/Details/productDetailUtils'
import React, { useState } from 'react'
import { DetailProperties } from './DetailProperties'
import PremiumInfoIconTooltip from './PremiumInfoIconTooltip'

const useStyles = makeStyles(() => ({
    containerFullWidth: {
        width: '100%',
    },
    fullViewHeading: {
        color: '#4F4F4F',
    },

    mainContent: {
        width: '100%',
        borderBottom: '6px solid #04325B',
        display: 'flex',
    },
    fullViewContainer: {
        width: 'fit-content',
        alignItems: 'center',
        marginLeft: 'auto',
    },

    title: {
        color: '#04325B',
        textTransform: 'uppercase',
        fontWeight: 500,
    },
}))

interface ListingDetailPropertiesProps {
    properties?: Partial<ManufacturerProductPropertyDetail>[]
    level?: string
}

export const ListingDetailProperties: React.FC<ListingDetailPropertiesProps> = ({
    properties,
    level,
}) => {
    const classes = useStyles()
    const [fullView, setFullView] = useState(false)
    const handleChange = () => {
        setFullView(!fullView)
    }
    if (!level || level === 'Basic') return null

    return (
        <GridContainer data-testid="ListingProperties">
            <GridItem className={classes.containerFullWidth}>
                <GridContainer
                    item
                    direction="row"
                    data-testid="detailProperties"
                >
                    <>
                        <GridItem className={classes.mainContent} sm={12}>
                            <GridContainer>
                                <GridItem md={7} sm={6} xs={12}>
                                    <Typography
                                        variant="h6"
                                        component="span"
                                        className={classes.title}
                                    >
                                        Properties
                                    </Typography>
                                    <PremiumInfoIconTooltip />
                                </GridItem>
                                <GridItem md={5} sm={6} xs={12}>
                                    <GridContainer
                                        className={clsx(
                                            classes.fullViewContainer
                                        )}
                                    >
                                        <SwitchButton
                                            checked={fullView}
                                            onChange={handleChange}
                                        />
                                        <Typography
                                            variant="body2"
                                            component="span"
                                            className={classes.fullViewHeading}
                                        >
                                            View Full List of Properties
                                            Available
                                        </Typography>
                                    </GridContainer>
                                </GridItem>
                            </GridContainer>
                        </GridItem>
                        <DetailProperties
                            listingLevel={level}
                            isFullView={fullView}
                            properties={getNormalizedProperties(properties)}
                            selectedData={getSelectedProperties(properties)}
                        />
                    </>
                </GridContainer>
            </GridItem>
        </GridContainer>
    )
}
